import { LuPanelLeft } from 'react-icons/lu'
import IconButton, { IconButtonProps } from '@mui/material/IconButton'

export default function Menu(props: IconButtonProps) {
  return (
    <IconButton
      size="medium"
      color="default"
      sx={({ shape }) => ({
        py: 0.3,
        px: 3,
        borderRadius: shape.borderRadiusLarge + 'px',
      })}
      {...props}
    >
      <LuPanelLeft />
    </IconButton>
  )
}
